var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C7.71831 16 7.48826 15.9061 7.30986 15.7183C7.13145 15.5305 7.04225 15.3052 7.04225 15.0423V8.95775H0.957746C0.694836 8.95775 0.469484 8.86385 0.28169 8.67606C0.0938967 8.48826 0 8.26291 0 8C0 7.71831 0.0938967 7.48826 0.28169 7.30986C0.469484 7.13145 0.694836 7.04225 0.957746 7.04225H7.04225V0.957746C7.04225 0.694836 7.13615 0.469484 7.32394 0.28169C7.51174 0.0938967 7.73709 0 8 0C8.28169 0 8.51174 0.0938967 8.69014 0.28169C8.86854 0.469484 8.95775 0.694836 8.95775 0.957746V7.04225H15.0423C15.3052 7.04225 15.5305 7.13615 15.7183 7.32394C15.9061 7.51174 16 7.73709 16 8C16 8.28169 15.9061 8.51174 15.7183 8.69014C15.5305 8.86854 15.3052 8.95775 15.0423 8.95775H8.95775V15.0423C8.95775 15.3052 8.86385 15.5305 8.67606 15.7183C8.48826 15.9061 8.26291 16 8 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add_white.6ff0e845093f6d0fb067631ff867538d.svg";
export { ForwardRef as ReactComponent };